// LinkShareBox — 链接分享
// 展示可分享的加入链接，支持一键复制

import { useToastStore } from '../common/Toast';

interface LinkShareBoxProps {
  url: string;
  pin?: string;
  onClose: () => void;
}

export function LinkShareBox({ url, pin, onClose }: LinkShareBoxProps) {
  const toast = useToastStore((s) => s.show);
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast('链接已复制', 'success');
    } catch {
      toast('复制失败，请手动选择', 'error');
    }
  };

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: '快船', text: '通过快船连接我', url });
      } catch {
        /* 用户取消 */
      }
    } else {
      copyLink();
    }
  };

  return (
    <div className="card p-6 max-w-sm w-full text-center animate-slide-up">
      <h3 className="text-lg font-bold text-ink mb-1">链接分享</h3>
      <p className="text-xs text-muted mb-5">将以下链接发送给对方，打开即可加入</p>

      <div className="flex items-stretch gap-2">
        <input
          readOnly
          value={url}
          className="input flex-1 text-xs"
          onFocus={(e) => e.currentTarget.select()}
          aria-label="加入链接"
        />
        <button type="button" onClick={copyLink} className="btn-primary px-3">
          复制
        </button>
      </div>

      {pin && (
        <div className="mt-4 rounded-md bg-warning/10 border border-warning/30 px-4 py-3 text-left">
          <p className="text-xs text-muted">连接时需输入 PIN</p>
          <p className="text-xl font-bold tracking-[0.3em] text-ink mt-1">{pin}</p>
        </div>
      )}

      <div className="mt-5 flex gap-2">
        <button type="button" onClick={share} className="btn-outline flex-1">
          📤 分享
        </button>
        <button type="button" onClick={onClose} className="btn-ghost">
          关闭
        </button>
      </div>
    </div>
  );
}
